module.exports = __webpack_public_path__ + "img/gadsden-regional-logo.023dea64.jpg";